
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import VFormBuilder from '../shared/form/VFormBuilder.vue';
import VLanguageField from '@/components/shared/form/VLanguageField.vue';
import { InputType } from '@/enums/InputType';
import { ReleasePlatformType as Platform } from '@/enums/ReleasePlatformType';
import { Release } from '@/interfaces/models/Release';
import StackedForm from '../../mixins/StackedForm';
import CustomerGroup from '@/mixins/CustomerGroup';

@Component({
  components: { VFormBuilder, VLanguageField },
})
export default class ReleasesForm extends mixins(StackedForm, CustomerGroup) {
  @Prop({ type: Boolean, default: false }) public editing!: boolean;

  public $refs!: {
    form: InstanceType<typeof VFormBuilder> & { form: any };
  };

  get platforms() {
    return Object.entries(Platform).map(([key, value]) => ({
      text: this.$t(`releases.form.platforms.${key}`),
      value,
    }));
  }

  get items() {
    return [
      {
        name: 'customerGroup',
        type: InputType.Autocomplete,
        label: 'releases.form.customerGroup',
        items: this.scopedCustomerGroups,
        multiple: false,
        rules: 'required',
        disabled: this.editing,
      },
      {
        name: 'platform',
        type: InputType.Select,
        label: 'releases.form.platform',
        rules: 'required',
        items: this.platforms,
      },
      { name: 'version', type: InputType.Text, label: 'releases.form.version', rules: 'required' },
      {
        name: 'description',
        type: InputType.Language,
        open: true,
        label: 'releases.form.description',
        rules: 'required',
      },
      {
        name: 'link',
        type: InputType.Text,
        label: 'releases.form.link',
        rules: (form: Release) => `required|url_ios_android:${form.platform}`,
      },
      {
        name: 'isLatest',
        type: InputType.Checkbox,
        default: false,
        label: 'releases.form.isLatest',
      },
      {
        name: 'forceUpdate',
        type: InputType.Checkbox,
        default: false,
        label: 'releases.form.forceUpdate',
      },
    ];
  }

  public getData() {
    return this.$refs.form.form;
  }
}
